import { useState } from 'react'
import { useAuth } from '../auth/AuthContext'

export function ChangePasswordPage() {
  const { changePassword, signOut } = useAuth()
  const [oldPassword, setOld] = useState('')
  const [newPassword, setNew] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const tooShort = newPassword.length > 0 && newPassword.length < 8
  const mismatch = confirm.length > 0 && confirm !== newPassword

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await changePassword(oldPassword, newPassword)
    } catch (problem) {
      setError(problem instanceof Error ? problem.message : 'Could not change the password.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="mark">Fulfil</div>
        <p className="tagline">Choose a new password to continue</p>

        <form className="login-form" onSubmit={submit}>
          {error ? <div className="alert error">{error}</div> : null}

          <div className="field">
            <label htmlFor="old">Current password</label>
            <input
              id="old"
              type="password"
              autoComplete="current-password"
              required
              value={oldPassword}
              onChange={(event) => setOld(event.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="new">New password</label>
            <input
              id="new"
              type="password"
              autoComplete="new-password"
              required
              value={newPassword}
              onChange={(event) => setNew(event.target.value)}
            />
            {tooShort ? (
              <span className="cell-sub">At least 8 characters.</span>
            ) : null}
          </div>

          <div className="field">
            <label htmlFor="confirm">Confirm new password</label>
            <input
              id="confirm"
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(event) => setConfirm(event.target.value)}
            />
            {mismatch ? <span className="cell-sub">These do not match.</span> : null}
          </div>

          <button
            className="btn primary"
            type="submit"
            disabled={busy || tooShort || mismatch || !oldPassword || !newPassword || !confirm}
          >
            {busy ? 'Saving…' : 'Set password'}
          </button>

          <button className="btn ghost" type="button" onClick={signOut}>
            Sign out instead
          </button>
        </form>
      </div>
    </div>
  )
}
